export default {
  name: 'convex-header',
  path: 'M0,0 L1,0 V0.875 C1,0.875,0.695,1,0.499,1 C0.303,1,0,0.875,0,0.875 L0,0',
};
